import axios from 'axios';

// 跨域认证信息 header 名
axios.defaults.timeout = 100000
// axios.defaults.withCredentials = true
// axios.defaults.baseURL = "/"
axios.defaults.baseURL = "https://www.jszj.net.cn/manage/"
// axios.defaults.baseURL = "http://8.148.179.6/"


// http method
const METHOD = {
    GET: 'get',
    POST: 'post'
}

/**
 * axios请求
 * @param url 请求地址
 * @param method {METHOD} http method
 * @param params 请求参数
 * @returns {Promise<AxiosResponse<T>>}
 */
async function request(url, method, params, config) {
    switch (method) {
        case METHOD.GET:
            return axios.get(url, { params, ...config })
        case METHOD.POST:
            return axios.post(url, params, config)
        default:
            return axios.get(url, { params, ...config })
    }
}

/**
 * 加载 axios 拦截器
 * @param interceptors
 * @param options
 */
function loadInterceptors(interceptors, options) {
    const { request, response } = interceptors
    // 加载请求拦截器
    request.forEach(item => {
        let { onFulfilled, onRejected } = item
        if (!onFulfilled || typeof onFulfilled !== 'function') {
            onFulfilled = config => config
        }
        if (!onRejected || typeof onRejected !== 'function') {
            onRejected = error => Promise.reject(error)
        }
        axios.interceptors.request.use(
            config => onFulfilled(config, options),
            error => onRejected(error, options)
        )
    })

    // 加载响应拦截器
    response.forEach(item => {

        let { onFulfilled, onRejected } = item
        if (!onFulfilled || typeof onFulfilled !== 'function') {
            onFulfilled = response => response
        }
        if (!onRejected || typeof onRejected !== 'function') {
            onRejected = error => Promise.reject(error)
        }
        axios.interceptors.response.use(
            response => onFulfilled(response, options),
            error => onRejected(error, options)
        )
    })
}

export {
    METHOD,
    axios,
    request,
    loadInterceptors,
};

